<template>
  <div class="tabs">
    <router-link class="tabs__item" :to="{ name: $consts.urls.URL_ADMIN_BUSINESS_DASHBOARD }">{{ $t('admin-business-dashboard-tabs') }}</router-link>
    <router-link class="tabs__item" :to="{ name: $consts.urls.URL_ADMIN_GATHERING_DASHBOARD }">{{ $t('admin-gathering-dashboard-tabs') }}</router-link>
    <router-link class="tabs__item" :to="{ name: $consts.urls.URL_ADMIN_STATS_DASHBOARD }">{{ $t('admin-stats-dashboard-tabs') }}</router-link>
    <router-link class="tabs__item" :to="{ name: $consts.urls.URL_ADMIN_SUPERADMIN_DASHBOARD }">{{ $t('admin-superadmin-dashboard-tabs') }}</router-link>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.tabs {
  border-bottom: 2px solid #c9c9c9;
  text-align: center;
  width: 100%;

  &__item {
    background-color: #ffffff;
    border: 2px solid #c9c9c9;
    border-radius: 4px 4px 0px 0px;
    color: #000000;
    display: inline-block;
    font-size: 20px;
    font-weight: 800;
    margin: 0 4px -2px;
    padding: 15px 15px 13px;
    text-decoration: none;
    transition: color 0.25s;

    &.router-link-active {
      color: #7667a7;
      border-bottom-color: #ffffff;
    }
  }
}

@media screen and (min-width: 768px) {
  .tabs {
    &__item {
      font-size: 24px;
      margin: 0 7px -2px;
      padding: 25px 35px 22px;
    }
  }
}
</style>
